itsoftApp.createModule("select", ["filters"], function () {
    var module = this;

    var queue = [];
    var libraryLoaded = false;
    var loadingStarted = false;
    module.selects = {
        filters: []
    }

    /**
     * Вызов всех функций, которые были добавлены
     * в массив queue в процессе загрузки библиотеки
     * (до этого момента их вызов привёл бы к ошибке).
     */
    var initQueue = function() {
        if (!libraryLoaded) {
            return false;
        }

        var qLen = queue.length;
        if (!qLen) {
            return;
        }

        DEBUG && console.log("[module select] initQueue function fired, queue.length: " + qLen);

        while (queue.length > 0) {
            // Взять первый элемент массива,
            // и вызвать его. Мы уже знаем, что это функция,
            // поэтому доп. проверка не требуется.
            queue.shift()();
        }
    };


    /**
     * Загрузить библиотеку и выполнить
     * отложенные функции из массива queue.
     */
    var loadAndInit = function() {
        var f = function() {
            libraryLoaded = true;
            initQueue();
        };

        // Случай, если библиотека вдруг уже загружена
        // (например, если она принудительна вставлена в html через <script>)
        itsoftApp.loadStyle("/assets/scripts/choices/choices.min.css");
        itsoftApp.loadScript("/assets/scripts/choices/choices.min.js", function() {
            DEBUG && console.log("[module select] library loaded, ready to init queue");
            f();
        });
    };


    /**
     * Добавление переданной функции в очередь на выполнение,
     * либо немедленное исполнение функции, если библиотека уже загружена.
     *
     * @param {function} func
     */
    var addEvent = function(func) {
        if (typeof func !== "function") {
            return;
        }

        // Если библиотека ещё не загружена, то добавляем в очередь
        if (!libraryLoaded) {

            // Если библиотека ещё не начала грузиться, то загружаем её
            // (причём откладываем загрузку библиотеки до полной загрузки самой страницы).
            if (!loadingStarted) {
                loadingStarted = true;
                DEBUG && console.log("%c--[module select] first function added. delegating loadAndInit to pageLoad module (or firing if page already loaded)", "font-style: italic; color: #999");
                itsoftApp.modules.pageLoad.addEvent(loadAndInit);
            }

            queue.push(func);
            DEBUG && console.log("[module select] function added, count of functions to init now: " + queue.length);

        // Если библиотека уже загружена, то просто вызываем переданную функцию
        } else {
            func();
        }
    };


    // Доступ к функциям
    // текущего модуля
    module.addEvent = addEvent;

    var setSelect = function (element) {
        var initSelect = function () {
            var form = element.closest("form");
            var selectItem = element.querySelector(".js-select-item");
            var selectWrapper = selectItem.closest(".js-select");
            var activeOptionValue;
            var activeSection;
            // console.log("initSelect")

            var getSelectName = function (select, string) {
                var selectClass = string;
                return selectClass += " choices--" + select.getAttribute("id"); 
            }

            var customSelect = new Choices(selectItem, {
                position: "bottom",
                searchEnabled: (function () {
                    if (selectItem.classList.contains("js-select-item--search")) {
                        return true;
                    } else {
                        return false;
                    }
                })(),
                loadingText: "",
                noResultsText: "",
                noChoicesText: "",
                itemSelectText: "",
                shouldSort: false,
                classNames: {
                    containerOuter: getSelectName(selectItem, "choices"),
                    placeholder: "form__select-placeholder"
                },
                removeItems: false,
                searchFields: ['label'],
                searchResultLimit: 10000,
                fuseOptions: {
                    findAllMatches: true,
                    threshold: 0.0
                },
                callbackOnInit: function () {
                    selectWrapper.classList.add("js-inited");
                }
            });

            var placeholder = selectWrapper.querySelector(".choices__list--dropdown .form__select-placeholder");
            var placeholderText = placeholder.textContent;
            var dropdown = selectWrapper.querySelector(".choices__list--dropdown");
            dropdown.setAttribute("data-placeholder", placeholderText);

            if (selectItem.classList.contains("js-filter-catalog")) {
                module.selects.filters.push(customSelect);
                customSelect.passedElement.element.addEventListener(
                    "choice",
                    function (event) {
                        setTimeout(function () {
                            itsoftApp.modules.filters.callback(form);
                        });
                    },
                    false
                );

                var searchValue = "";

                customSelect.passedElement.element.addEventListener(
                    "search",
                    function (event) {
                        searchValue = event.detail.value;
                    },
                    false
                );

                customSelect.passedElement.element.addEventListener(
                    "showDropdown",
                    function (event) {
                        var input = selectWrapper.querySelector(".choices__list--dropdown .choices__input");

                        if (input) {
                            input.value = searchValue;
                        }
                    },
                    false
                );
            }
        }

        addEvent(initSelect);
    }

    this.callback = setSelect;
});